var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Icon_metro-twitter","data-name":"Icon metro-twitter","d":"M22.874,6.771a8.328,8.328,0,0,1-2.392.656,4.178,4.178,0,0,0,1.831-2.3,8.339,8.339,0,0,1-2.645,1.011,4.169,4.169,0,0,0-7.1,3.8A11.826,11.826,0,0,1,3.984,5.58a4.17,4.17,0,0,0,1.289,5.561,4.148,4.148,0,0,1-1.887-.521c0,.017,0,.035,0,.052a4.168,4.168,0,0,0,3.341,4.084,4.172,4.172,0,0,1-1.881.071,4.17,4.17,0,0,0,3.891,2.893A8.357,8.357,0,0,1,3.564,19.5a8.448,8.448,0,0,1-.994-.058,11.79,11.79,0,0,0,6.385,1.872A11.771,11.771,0,0,0,20.807,9.466q0-.271-.012-.539a8.462,8.462,0,0,0,2.079-2.156Z","transform":"translate(-2.571 -4.817)","fill":"#fff"}));
}

Twitter.defaultProps = {"width":"20.303","height":"16.5","viewBox":"0 0 20.303 16.5"};

module.exports = Twitter;

Twitter.default = Twitter;
